export default __webpack_public_path__ + "static/media/ic_Red_Cancel.f336be39.svg";